var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 63,
    viewBox: "0 0 65 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 62.0621,
    fill: "#155DAF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 62.0621,
    fill: "#155DAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9492 22.6638H28.6554V28.2825H40.9209V32.9463H28.6554V39.5198H42.2062V44.1836H23V18H41.9492V22.6638Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/E.d47d1ae5699a7a24753e7770c6be527f.svg";
export { ForwardRef as ReactComponent };